import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "introduction" }
const _hoisted_9 = { class: "createTime" }
const _hoisted_10 = {
  key: 0,
  class: "pagination"
}
const _hoisted_11 = ["onClick"]

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import store from '@/store';
// import ContactUs from '@/components/ContactUs.vue'
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsView',
  setup(__props) {

const loadUrl: any = ref({})
const newsListAll: any =  ref([])
const newsList: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `新闻中心 / 新闻详情 / ${title}`
}

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  newsList.value = [...newsListAll.value].slice((value - 1) * 8, value * 8)
}


const getData = (columnId: number) => {
  selectCommonElement({ columnId, appId: 2 }).then((res: any) => {
    newsListAll.value = [...res].map((e: any) => {
      const date = new Date(e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = date.getHours();
      const mx = date.getMinutes();
      const s = date.getSeconds();
      e.createTime = `${y}-${m}-${d}`
      return e;
    })
    newsList.value = [...newsListAll.value].slice(0, 8)
    paginationValue.value = Math.ceil(newsListAll.value?.length / 8) || 0
  })
}

onMounted(async () => {
  const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
  loadUrl.value = { news }

  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  const columnId = +path.query.type || 5
  getData(columnId);
})
watch(() => store.state.programmeIndex, (newState: any) => {
  getData(newState)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.news
      }, null, 8, _hoisted_3),
      _createElementVNode("div", null, _toDisplayString(_unref(store).state.programmeIndex == 6 ? '行业新闻' : '公司新闻'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (toOtherPath(item.relatedHtmlId, item.title))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.introduction), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.createTime), 1)
          ])
        ], 8, _hoisted_5))
      }), 128))
    ]),
    (newsListAll.value.length > 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "prev",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeData(Math.max(0, paginationIndex.value - 1) + 1)))
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationValue.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (changeData(item)),
              class: _normalizeClass(paginationIndex.value == index ? 'active' : ''),
              key: item
            }, _toDisplayString(item), 11, _hoisted_11))
          }), 128)),
          _createElementVNode("div", {
            class: "next",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeData(Math.min(paginationIndex.value + 1, paginationValue.value - 1) + 1)))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})